import OrderStatus from "@@/core/components/order/OrderStatus/OrderStatus";
import { BTooltip, BFormGroup, BFormInput } from 'bootstrap-vue'
import VueBarcode from "vue-barcode";

export default {
  name: "OrderInfo",
  props: {
    order: Object
  },
  data() {
    return {
      barcode: '',
      disabled: false,
    };
  },
  components: {
    VueBarcode,
    OrderStatus, BTooltip, BFormGroup, BFormInput
  },
  methods: {
    updateOrderStatus() {
      this.$emit('update-order-status')
    },
    showCustomer(customer) {
      this.$emit('show-customer', customer)
    },
    async modifyBarcode() {
      this.disabled = true;
      try {
        const response = await this.$axios.put(`admin/orders-update-barcode/${this.order.id}`, {
          barcode: this.barcode,
        });
        this.$root.notify(response.data.message, "success");
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    }
  }
}
